module.exports = __webpack_public_path__ + "img/jazzar.2a6abf30.png";